import React from 'react'

import ReactPlayer from 'react-player/lazy'

export const Youtube = ({ videoURL, ...props }) => {
  const style = {
    border: '0',
    height: '100%',
    left: '0',
    position: 'absolute',
    top: '0',
    width: '100%',
  }

  return (
    <ReactPlayer
      width="100%"
      height="100%"
      style={style}
      url={videoURL}
      controls={true}
      pip={false}
      disablePictureInPicture={true}
      config={{
        youtube: {
          playerVars: { disablepictureinpicture: 'true' },
        },
      }}
      {...props}
    />
  )
}
